export const SortingAlgorithms = [
  {
    id: 1,
    name: "Bubble Sort",
  },
  {
    id: 2,
    name: "Selection Sort",
  },
  {
    id: 3,
    name: "Insertion Sort",
  },
  {
    id: 4,
    name: "Merge Sort",
  },
  {
    id: 5,
    name: "Quick Sort",
  },
  {
    id: 6,
    name: "Heap Sort",
  },
];
